import { render, staticRenderFns } from "./RegularExerciseEditor.vue?vue&type=template&id=94c4d95e&scoped=true&"
import script from "./RegularExerciseEditor.vue?vue&type=script&lang=js&"
export * from "./RegularExerciseEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c4d95e",
  null
  
)

export default component.exports